exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body {\n  margin: 0;\n  padding: 0;\n  font-family: sans-serif;\n}\n\npre {\n    display: block;\n    margin: 0 0 10px;\n    padding: 0px;\n    font-size: 13px;\n    line-height: 1.42857143;\n    word-break: break-all;\n    word-wrap: break-word;\n    color: #333333;\n    background-color: #f8f8f8;\n    border-style: none;\n    border-radius: 0px;\n    border-left-color: #64a0af;\n    border-left-style: solid;\n    border-left-width: 3px;\n    padding-left: 10px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./src/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss"}!./src/index.css
// module chunks = 0